import {ref} from 'vue'
export const MOBILE_COUNTRY_CODE = '+234';
export const RE_PHONE_NUMBER =/^[0-9]*$/;
export const CURRENCY_SYMBOL = ref(''); //₦ 